@use "Styles/mixins";
@use "Styles/includes/variables";

:host {
    display: block;
    font-family: variables.$fontQuaternary;
}
